import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=456ffefe"
var script = {}
import style0 from "./Example.vue?vue&type=style&index=0&id=456ffefe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports